import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "davide_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, size = null, qty = 1) => {
    setItems((prev) => {
      const key = `${product.id}__${size || ""}`;
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        key, product_id: product.id, name: product.name, price: product.price,
        image_url: product.image_url, size, quantity: qty,
      }];
    });
    setOpen(true);
  };
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const updateQty = (key, qty) => setItems((prev) => prev.map((i) =>
    i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, updateQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
